import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import data from "../api/databaseApi";

import AddItem from "./AddItem"; 
const ClassList = () =>{
    const navigate = useNavigate();
    const { semesterid } = useParams();
    const [ semesterName, setSemesterName] = useState('Hello');
    const [ classList, setClassList ] = useState([]);
    const getClasses = data.getClasses;
    useEffect(() =>{
        const update = async () =>{
            const name = (await data.getSemester(semesterid)).name;
            setSemesterName(name);
            const listOfClasses = await getClasses(semesterid);
            setClassList(listOfClasses)
        }
        update();
    },[semesterid,getClasses]);
    const addClass = async (newClass) =>{
        const newList = await data.addClass(newClass,semesterid);
        setClassList([...classList,newList]);
    }
    const removeClass = async (classIdToRemove) => {
        data.removeClass(classIdToRemove);
        setClassList(classList.filter((classItem) =>{
            if(classItem.id !== classIdToRemove){
                return classItem
            }
            return null
        }));
    }
    return (
        <div className="container">
            <div className="container">
                <div className="row">
                    <button className="col btn btn-light border border-1" onClick={()=>{navigate(-1)}}>Back</button>
                </div>
            </div>
            <table className="table table-striped table-hover table-bordered">
                <thead className="table-dark">
                    <tr>
                        <th scope="col">
                            <div className="row">
                                <div className="col">Classes of {semesterName}</div>
                                <div className="col text-end">Count: {classList.length}</div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {classList.map((clas) =>{
                        return (
                            <tr key={clas.id}>
                                <td>
                                    <div className="row">
                                        <div className="col-11" style={{cursor:"pointer"}} onClick={()=>{navigate(`/student-list/${clas.id}`)}}>
                                            {clas.name}
                                        </div>
                                        <div className="col text-center"><FaTimes style={{cursor:"pointer"}} onClick={()=>{removeClass(clas.id)}}/></div>
                                    </div>
                                </td>
                            </tr>
                            
                        )
                    })}
                    {classList.length === 0 && (
                        <tr>
                            <td>No Classes found</td>
                        </tr>
                    )}
                    <tr>
                        <td>
                           <AddItem title='Add Class' prompts={[{prompt:"Class Name",varName:"name"}]} addItem={addClass}/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default ClassList